import { Box, Typography } from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"

import { jewlr_t } from "helpers/application"

const Warranty = () => (
  <Box contain fontWeight="light" lineHeight="copy" mb={1} pb={1}>
    <Box mt={4}>
      <Typography as="h1" fontWeight="normal" textAlign="center" variant="h1">
        Warranty Information
      </Typography>
    </Box>
    <Box mb={10} pl={{ _: "0.6em" }} px={{ _: 1, tablet: 0 }}>
      <Typography my={2} variant="body3">
        We offer a one-year warranty on all our {jewlr_t("terms.jewelry")}{" "}
        against manufacturing defects and workmanship. The warranty becomes void
        if the product has been subjected to misuse or has been altered by
        anyone other than an authorized Lee Fiori representative.
      </Typography>

      <Typography mb={2} variant="body3">
        Our dedicated Quality Assurance Team inspects every item before shipment
        to ensure that you receive a high-quality piece. In the rare event that
        your item has a defect, please use our{" "}
        <Typography as={Link} to="/order/repair" underline="true">
          Request Repair Form
        </Typography>{" "}
        to request a repair, or contact a customer service representative at{" "}
        <Typography
          as="a"
          href={`tel:${sl.config.customer_service_toll_free}`}
          underline
        >
          {sl.config.customer_service_toll_free}
        </Typography>{" "}
        , and we&apos;d be happy to assist you in getting your item repaired.
        Please include your order number and contact information in your
        communications with us.
      </Typography>

      <Typography mb={2} variant="body3">
        {" "}
        PLEASE NOTE:
      </Typography>
      <Typography as="ul" mb={2}>
        <li>
          The customer will be responsible for any {jewlr_t("terms.shipping")}{" "}
          charges related to a warranty repair.
        </li>
        <li>
          We reserve the right to void the warranty on any item that shows signs
          of modification, abuse or damage beyond normal wear, as deemed by our{" "}
          {jewlr_t("terms.jewelry")} professionals.
        </li>
        <li>We will not be responsible for lost or stolen items.</li>
      </Typography>

      <Typography variant="body3">
        For any questions, please email us at{" "}
        <Typography
          as="a"
          href={"mailto:" + sl.config.customer_service_email}
          underline
        >
          {sl.config.customer_service_email}
        </Typography>
      </Typography>
    </Box>
  </Box>
)

export default Warranty
